import { CalendarRoute } from 'routes';

export const AgendaRoute = `${CalendarRoute}/agenda`;
export const SearchEventsRoute = `${AgendaRoute}/search`;
